// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2p4iS","icon":"styles_icon__ffrHy"};